import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { tv, type VariantProps } from 'tailwind-variants';
import { INTENTS, type StatusIntents } from '~/theme/variants';

export function cn(...classes: ClassValue[]): string {
	return twMerge(clsx(classes));
}

const focusIntentEntries = Object.entries(INTENTS) as [StatusIntents, (typeof INTENTS)[StatusIntents]][];

export const focusRingVariants = tv({
	base: '',
	variants: {
		intent: Object.fromEntries(focusIntentEntries.map(([intent, spec]) => [intent, spec.focus.ring])) as Record<StatusIntents, string>,
		isFocusVisible: {
			true: 'outline-2 outline-offset-2 ring-2 forced-colors:outline-[Highlight]',
			false: 'outline-0 ring-0'
		},
		isFocusWithin: {
			true: 'ring-2'
		},
		isInvalid: {
			true: '!border-red-600 !ring-red-600/50'
		}
	},
	compoundVariants: [
		...focusIntentEntries.map(([intent, spec]) => ({ intent, isFocusVisible: true, class: spec.focus.focusVisibleOutline })),
		...focusIntentEntries.map(([intent, spec]) => ({ intent, isFocusWithin: true, class: spec.focus.focusWithinRing }))
	],
	defaultVariants: {
		intent: 'primary'
	}
});
type FocusRingVariants = VariantProps<typeof focusRingVariants>;

export interface FocusRingProps {
	intent?: FocusRingVariants['intent'];
	isFocusVisible?: boolean;
	isFocusWithin?: boolean;
	isInvalid?: boolean;
}

export function focusRing(props: FocusRingProps = {}): string {
	return focusRingVariants(props);
}
